module.exports = __webpack_public_path__ + "img/shopping-thumb.f38a70fd.jpg";